// @flow
import { branch, renderComponent, type HOC, type Component } from "recompose"
import Empty from "./Empty"
import { compose, either, pathEq, prop, isNil } from "ramda"

const defaultPredicate = either(
  compose(
    isNil,
    prop("data"),
  ),
  pathEq(["data", "length"], 0),
)

const withEmpty = <T>(
  predicate: T => boolean = defaultPredicate,
  component: Component<T> = Empty,
): HOC<T, T> => branch(predicate, renderComponent(component))

export default withEmpty



// WEBPACK FOOTER //
// ./src/hoc/withEmpty/index.js